import { SparkleIcon } from '@phosphor-icons/react';
import { Card } from '@/components/ui/card';

interface Props {
  detectedCount: number;
  onReview: () => void;
}

/** Compact emerald nudge surfaced when the detector has candidates awaiting review. */
export function DetectionCard({ detectedCount, onReview }: Props) {
  if (detectedCount <= 0) return null;

  return (
    <Card variant="flat" className="flex items-center justify-between gap-3 rounded-[var(--radius-3xl)] border-success-border bg-success-surface p-4 shadow-[var(--shadow-1)]">
      <span className="flex min-w-0 items-center gap-2.5 text-sm text-text-secondary">
        <SparkleIcon size={16} weight="fill" className="shrink-0 text-success-text" />
        <span className="min-w-0">
          <span className="font-medium text-text-primary">
            {detectedCount} {detectedCount === 1 ? 'recorrência' : 'recorrências'}
          </span>{' '}
          para revisar
        </span>
      </span>
      <button
        type="button"
        onClick={onReview}
        className="shrink-0 rounded-lg bg-brand-primary px-4 py-2 text-xs font-semibold text-on-brand transition-colors hover:bg-brand-primary-hover"
      >
        Revisar
      </button>
    </Card>
  );
}
